module.exports = __webpack_public_path__ + "static/ps4.6e4d4446.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/ps4.png
// module id = 810
// module chunks = 219805994829571